// get is a reserved word in the language
export function getter(t, p) {
    return Reflect.get(t, p);
}
//# sourceMappingURL=getter.js.map